import React, { useState, useEffect } from 'react'

import tokml from 'geojson-to-kml'

import CloseIcon from '@material-ui/icons/Close'

import { makeStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import TextField from '@material-ui/core/TextField'
import Alert from '@material-ui/lab/Alert'
import IconButton from '@material-ui/core/IconButton'

import '../filesMenu.css'

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    width: 120,
    margin: 'auto',
    '& .MuiOutlinedInput-root': {
      height: 37,
    },
    '& .MuiSelect-outlined': {
      height: 37,
    },
    '& .MuiSelect-select': {
      height: 37,
    },
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
}))

function DownloadModal(props) {
  const [fileName, setFileName] = useState('')
  const [fileExt, setFileExt] = useState('.kml')
  const [selectedProject, setSelectedProject] = useState('')
  const [alerta, setAlerta] = useState(false)

  const classes = useStyles()

  useEffect(() => {
    setSelectedProject(props.projects[0].projectName)
  }, [])

  const changeName = (event) => {
    const { name, value } = event.target
    setFileName(value)
  }

  const download = () => {
    if (props.features.features.length !== 0) {
      const filtered = {
        type: 'FeatureCollection',
        features: props.features.features.filter((val) => val.properties.id === selectedProject),
      }
      filtered.features.map((data) => {
        data.properties.colorCode ? (data.properties.colorCode = JSON.stringify(data.properties.colorCode)) : null
        data.properties.colorCodeB ? (data.properties.colorCodeB = JSON.stringify(data.properties.colorCodeB)) : null
        data.properties.dottedLine ? (data.properties.dottedLine = JSON.stringify(data.properties.dottedLine)) : null
      })
      // console.log(filtered)
      const kml = tokml(filtered, {
        name: 'name',
        description: 'description',
        simplestyle: true,
      })

      if (fileExt === '.kml') {
        var file = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' })
        var url = window.URL.createObjectURL(file)
        var a = document.createElement('a')
        a.href = url
        a.download = fileName + fileExt
        a.click()
        props.setDownloadModal(false)
      } else if (fileExt === '.geojson') {
        var file = new Blob([JSON.stringify(filtered)], { type: 'application/json' })
        var url = window.URL.createObjectURL(file)
        var a = document.createElement('a')
        a.href = url
        a.download = fileName + fileExt
        a.click()
        props.setDownloadModal(false)
      }
    }
    if (props.features.features.length == 0) {
      setAlerta(true)
    }
  }
  return (
    <div className="save-file-modal">
      <IconButton
        size="small"
        component="span"
        onClick={() => props.setDownloadModal(false)}
        className="sf-modal-close"
      >
        <CloseIcon />
      </IconButton>
      <h3>Download Geometries</h3>
      <div style={{ display: 'flex', flexFlow: 'column', gap: '15px' }}>
        <div style={{ display: 'flex' }}>
          <label style={{ height: 'fit-content', marginRight: '10px', alignSelf: 'center' }}>File Name:</label>
          <TextField
            id="filled-name"
            size="small"
            // style={{ width: '100%' }}
            variant="outlined"
            value={fileName}
            onChange={changeName}
          />
        </div>

        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel htmlFor="outlined-age-native-simple">File Type</InputLabel>
          <Select native onChange={(evt, val) => setFileExt(evt.target.value)} autoWidth={true} label="File Type">
            <option value={'.kml'}>KML</option>
            <option value={'.geojson'}>Geojson</option>
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel htmlFor="outlined-age-native-simple">Select Project</InputLabel>
          <Select
            native
            onChange={(evt, val) => setSelectedProject(evt.target.value)}
            autoWidth={true}
            label="Select Project"
          >
            {props.projects.map((val) => (
              <option value={val.projectName}>{val.projectName}</option>
            ))}
          </Select>
        </FormControl>
        <button
          className="files-manager-btn ripple"
          style={{ width: '140px', margin: 'auto', display: 'block' }}
          onClick={() => download()}
        >
          DOWNLOAD
        </button>
        {alerta ? (
          <Alert severity="warning">There is no geometry drawn in the map</Alert>
        ) : (
          <Alert severity="info">Click the download button to start</Alert>
        )}
      </div>
    </div>
  )
}

export default DownloadModal
